import React from "react";
import { Button, Form, FormControl } from "react-bootstrap";
import PropTypes from "prop-types";
import classes from "./ProductsFilterOptions.module.scss";
import { PRODUCT_STATUS } from "../../../../constants/productConstants";

const ProductsFilterOptions = ({
  t,
  productTypeFilter,
  setProductTypeFilter,
  statusFilter,
  setStatusFilter,
  productTypes,
  applyFilters,
}) => {
  const handleReset = () => {
    setProductTypeFilter("");
    setStatusFilter("all");
  };

  return (
    <div className={classes["products-filter-options"]}>
      {/* Product Type Filter */}
      <div className="filter-group">
        <label htmlFor="product-type-filter">{t("product_type")}</label>
        <FormControl
          as="select"
          id="product-type-filter"
          value={productTypeFilter}
          onChange={(e) => setProductTypeFilter(e.target.value)}
        >
          <option value="">{t("all_types")}</option>
          {productTypes.length > 0 ? (
            productTypes.map((type) => (
              <option key={type._id} value={type._id}>
                {type.product_longname}
              </option>
            ))
          ) : (
            <option disabled>{t("no_product_types")}</option>
          )}
        </FormControl>
      </div>

      {/* Status Filter */}
      <div className={classes["filter-group"]}>
        <label>{t("status")}</label>
        {/* "All" option is special and should always be first */}
        <Form.Check
          type="radio"
          label={t("all")}
          name="status-filter"
          id="status-all"
          checked={statusFilter === "all"}
          onChange={() => setStatusFilter("all")}
        />

        {/* Map through status options */}
        {Object.entries(PRODUCT_STATUS).map(([statusCode, translationKey]) => (
          <Form.Check
            key={statusCode}
            type="radio"
            label={t(translationKey)}
            name="status-filter"
            id={`status-${statusCode}`}
            checked={statusFilter === statusCode}
            onChange={() => setStatusFilter(statusCode)}
          />
        ))}
      </div>

      {/* Apply and Reset Buttons */}
      <div className={classes["filter-action-buttons-container"]}>
        <Button variant="secondary" onClick={handleReset}>
          {t("reset")}
        </Button>
        {/*   <Button variant="primary" onClick={applyFilters}>
          {t("applyFilters")}
        </Button> */}
      </div>
    </div>
  );
};

ProductsFilterOptions.propTypes = {
  t: PropTypes.func.isRequired,
  productTypeFilter: PropTypes.string.isRequired,
  setProductTypeFilter: PropTypes.func.isRequired,
  statusFilter: PropTypes.string.isRequired,
  setStatusFilter: PropTypes.func.isRequired,
  productTypes: PropTypes.array.isRequired,
  applyFilters: PropTypes.func.isRequired,
};

export default ProductsFilterOptions;
